import { AnimatePresence, motion } from "motion/react";
// import { CloseOutlined } from "@ant-design/icons";
import "./PopUpGlobal.scss";

interface PopUpGlobalProps {
  visible: boolean;
  onClose?: () => void;
  children?: React.ReactNode;
}

const PopUpGlobal: React.FC<PopUpGlobalProps> = ({
  visible,
  onClose,
  children,
}) => {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="pop-up-global-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className="pop-up-global-content"
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            transition={{ type: "spring", stiffness: 300, damping: 25 }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* <button className="pop-up-global-close" onClick={onClose}>
              <CloseOutlined />
            </button> */}
            {children}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PopUpGlobal;
